// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__1zqOs","addWidgetButton":"Header_addWidgetButton__1z_s7","dashboardTabs":"Header_dashboardTabs__3QMxv","active":"Header_active__2OrJY"};